import { Section } from '@/components/layout';
import { Reveal } from '@/components/motion';
import { ResponsiveImage } from '@/components/media';
import { Eyebrow } from '@/components/typography';
import { DividerCorazon } from '../icons/BogotaIcons';
import styles from './PruebaSocialBogota.module.css';

/* =============================================================================
 * S6 · PRUEBA SOCIAL REAL  —  ADICIÓN EXIGIDA POR EL BRIEF (ADR-006)
 * -----------------------------------------------------------------------------
 * El mockup `DEMO_2_Bogota.png` NO dibuja esta sección. La piden el master
 * prompt §7.7 y `07_ARQUITECTURA_LANDINGS.md` §6.4. Se construye con el
 * lenguaje visual del mockup: crema, navy, filete dorado y divisor de corazón.
 *
 * LÍNEA ROJA (ADR-003 §1): la ÚNICA prueba social real del proyecto es la foto
 * `comun/charla-miami-2023`. Aquí van la foto y su pie, y NADA MÁS: ni cifras
 * de asistentes, ni nombres, ni testimonios. Si algún día llegan testimonios
 * acreditados, se añaden; hasta entonces el vacío se queda vacío.
 * ========================================================================== */
export function PruebaSocialBogota() {
  return (
    <Section background="alt" labelledBy="bogota-prueba-titulo" className={styles.section}>
      <Reveal className={styles.wrap}>
        <div className={styles.head}>
          <Eyebrow ink="gold" align="center">
            Ya ha ocurrido antes
          </Eyebrow>

          {/* El titular es el MENSAJE, no el nombre del encuentro de 2023 —que
              baja al cuerpo, donde sí se entiende—. Encargo del cliente
              (28-jul-2026): «un título que diga algo como otros ya han estado».
              Sin «en otras giras»: no las ha habido, y afirmarlo sería inventar
              un historial (ADR-003 §2). */}
          <h2 id="bogota-prueba-titulo" className={styles.title}>
            Otros ya han estado antes
          </h2>

          <DividerCorazon className={styles.divider} />

          <p className={styles.body}>
            La Gira 2027 no empieza de cero. Esta es una fotografía real del encuentro «Semillas
            Estelares» que Azrahel del Mayor reunió en Miami en 2023.
          </p>
        </div>

        <figure className={styles.figure}>
          <ResponsiveImage
            asset="comun/charla-miami-2023"
            className={styles.media}
            sizes="(min-width: 64rem) 34rem, 92vw"
          />
          <figcaption className={styles.caption}>
            Encuentro «Semillas Estelares» · Miami, 2023.
            <span className={styles.note}>Una foto real, sin cifras ni testimonios de adorno.</span>
          </figcaption>
        </figure>
      </Reveal>
    </Section>
  );
}
